import axios from "axios";
import AppNotification from "./AppNotification";
import { clientToken } from "./Constant";
import { getValue } from "./Storage";

const _baseURL = import.meta.env.VITE_REACT_APP_API_URL;
export const _baseTimeOut = import.meta.env.VITE_REACT_APP_API_TIMEOUT || 50_000;

const axiosInstance = axios.create({
  baseURL: _baseURL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
  },
  timeout: _baseTimeOut,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getValue(clientToken);
    // if (token) {
    if (token && token != null && token !== "null" && token !== "undefined") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage =
      error?.response?.data?.response_message || error?.message || error;

    AppNotification.error({
      msg: "Error",
      desc: errorMessage,
    });

    return Promise.reject(errorMessage);
  }
);

export default axiosInstance;
